import { Input, Directive } from '@angular/core';
import { CardInstance } from '@workflow/class/card.service';
import { FieldInstance } from '@workflow/class/field.service';
import { PageInstance } from '@workflow/class/page.service';
import { Observable, of } from 'rxjs';

/** Base Component Class for card elements */
@Directive()
export class BuildingBlockElementsBaseComponent {
  /** * Dynamic Page object.  */
  @Input()
  public page: PageInstance;

  /** Dynamic Card object. */
  @Input()
  public card: CardInstance;

  /** field input to be passed in from cards component. */
  @Input() public field: FieldInstance;

  /** Page Submitted Observable. */
  @Input()
  public pageSubmitted$: Observable<boolean> = of(false);
}
